var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "page search-page mypc" }, [
    _c("div", { staticClass: "container container--small" }, [
      _c("div", { staticClass: "row" }, [
        _vm.searchError
          ? _c("div", { staticClass: "column column--2-3" }, [
              _c("p", [_vm._v("Error. Please try again later")]),
            ])
          : _vm.totalCount
          ? _c("div", { staticClass: "column column--2-3" }, [
              _c("div", { staticClass: "search-page__info" }, [
                _c(
                  "div",
                  { staticClass: "search-page__info-count" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.totalCount >= 10000 ? "10,000+" : _vm.totalCount
                        ) + " results"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.searchValue
                      ? [
                          _vm._v("\n              found for\n              "),
                          _c("span", { attrs: { id: "results-for" } }, [
                            _vm._v(_vm._s(_vm.searchValue)),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.containsQuery()
                  ? _c(
                      "div",
                      { staticClass: "search-page__info-sorting" },
                      [
                        _c(
                          "div",
                          { staticClass: "search-page__info-sorting-label" },
                          [_vm._v("Sort by")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          {
                            attrs: { "split-button": "", trigger: "click" },
                            on: { command: _vm.handleClickSort },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.sort.find(
                                    (el) => el.value === _vm.sortValue
                                  ).name
                                ) +
                                "\n              "
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              _vm._l(_vm.sort, function (item) {
                                return _c(
                                  "el-dropdown-item",
                                  {
                                    key: item.value,
                                    attrs: { command: item.value },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.name) +
                                        "\n                "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "resultsTabs",
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: `All (${
                              _vm.totalCount >= 10000
                                ? "10,000+"
                                : _vm.totalCount
                            })`,
                            name: "all",
                          },
                        },
                        [
                          _vm._l(_vm.allResultsTab, function (article) {
                            return _c(
                              "div",
                              {
                                key: article.nid,
                                staticClass: "search-page__result-item",
                                staticStyle: { "margin-top": "20px" },
                              },
                              [
                                _c("ArticleSearchCard", {
                                  key: article.nid,
                                  attrs: {
                                    title: _vm.markedWords(article.title),
                                    desc: _vm.markedWords(article.body),
                                    link: article.url,
                                    date: article.date,
                                    author: article.author_name,
                                    tags: article.tags,
                                    "has-access":
                                      article.type === "regulatory_update"
                                        ? _vm.checkHsAccess(
                                            article.jurisdictions
                                          )
                                        : true,
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm.totalCount && _vm.totalCount > 10
                            ? _c(
                                "div",
                                { staticClass: "search-page__pagination" },
                                [
                                  _c("Pagination", {
                                    attrs: {
                                      "current-page": _vm.currentPage,
                                      total: _vm.pagination.count,
                                    },
                                    on: { changePage: _vm.searchPaging },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.results, function (item) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: item.name,
                            attrs: {
                              label: `${item.name}(${item.count})`,
                              disabled: item.count === 0,
                            },
                          },
                          [
                            _vm._l(item.results, function (article) {
                              return _c(
                                "div",
                                {
                                  key: article.nid,
                                  staticClass: "search-page__result-item",
                                  staticStyle: { "margin-top": "20px" },
                                },
                                [
                                  _c("ArticleSearchCard", {
                                    key: article.nid,
                                    attrs: {
                                      title: _vm.markedWords(article.title),
                                      desc: _vm.markedWords(article.body),
                                      link: article.url,
                                      date: article.date,
                                      author: article.author_name,
                                      tags: article.tags,
                                      "has-access":
                                        article.type === "regulatory_update"
                                          ? _vm.checkHsAccess(
                                              article.jurisdictions
                                            )
                                          : true,
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            item.count && item.count > 10
                              ? _c(
                                  "div",
                                  { staticClass: "search-page__pagination" },
                                  [
                                    _c("Pagination", {
                                      attrs: {
                                        "current-page": _vm.currentPage,
                                        total: item.count,
                                      },
                                      on: { changePage: _vm.searchPaging },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ])
          : _c("div", { staticClass: "column column--2-3" }, [
              _c("p", [_vm._v("No results")]),
            ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column column--1-3" },
          [
            _c(
              "Sidebar",
              {
                staticClass: "test",
                attrs: { "props-handle-click-close": _vm.toggleSidebar },
              },
              [
                _c("FilterBlock", {
                  ref: "filterBlock",
                  attrs: {
                    title: "SEARCH FILTERS",
                    reset: true,
                    "filter-data": _vm.searchFilter,
                    "initial-selection": _vm.selectedFilterIds,
                  },
                  on: {
                    filterChanged: _vm.filterChanged,
                    filterReset: _vm.filterReset,
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "watchlist section section-border--top section-border--right",
                  },
                  [
                    _c("TitleBlock", {
                      attrs: { text: "Watchlist", color: "brightblue" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "watchlist__wrapper" },
                      _vm._l(_vm.watchlist, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "watchlist__item",
                            on: {
                              click: function ($event) {
                                return _vm.onWatchlistItemClicked(
                                  item.id,
                                  item.tags
                                )
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(item.name))]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "watchlist__item-link",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleLinkAction(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    Edit\n                  "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }